export enum ESocketRoutes {
    Message = 'send-message'
}